import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header
      data-testid="nav-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-novya-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <span className="font-display font-black text-2xl tracking-tighter">
            Novya<span className="text-novya-accent">.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-mono text-xs tracking-[0.15em] uppercase">
          <Link data-testid="nav-programs" to="/programs" className="link-underline text-novya-ink hover:text-novya-accent transition-colors">Programs</Link>
          <Link data-testid="nav-about" to="/about" className="link-underline text-novya-ink hover:text-novya-accent transition-colors">About</Link>
          {user && (
            <Link data-testid="nav-dashboard" to="/dashboard" className="link-underline text-novya-ink hover:text-novya-accent transition-colors">Dashboard</Link>
          )}
          {user?.role === "admin" && (
            <Link data-testid="nav-admin" to="/admin" className="link-underline text-novya-accent hover:text-novya-ink transition-colors">Admin</Link>
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <span data-testid="nav-user-email" className="font-mono text-xs text-novya-muted">{user.email}</span>
              <button
                data-testid="nav-logout-btn"
                onClick={handleLogout}
                className="px-4 py-2 border border-novya-ink text-novya-ink text-sm font-medium hover:bg-novya-ink hover:text-white transition-colors"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link data-testid="nav-login-btn" to="/login" className="px-4 py-2 text-sm font-medium text-novya-ink hover:text-novya-accent transition-colors">Log in</Link>
              <Link
                data-testid="nav-apply-btn"
                to="/register"
                className="px-5 py-2 bg-novya-ink text-white text-sm font-medium hover:bg-novya-accent transition-colors"
              >
                Apply now
              </Link>
            </>
          )}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-novya-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-novya-border bg-white">
          <div className="px-6 py-4 flex flex-col gap-4 font-mono text-xs tracking-[0.15em] uppercase">
            <Link data-testid="nav-mobile-programs" to="/programs" onClick={() => setOpen(false)}>Programs</Link>
            <Link data-testid="nav-mobile-about" to="/about" onClick={() => setOpen(false)}>About</Link>
            {user ? (
              <>
                <Link data-testid="nav-mobile-dashboard" to="/dashboard" onClick={() => setOpen(false)}>Dashboard</Link>
                <button data-testid="nav-mobile-logout" onClick={() => { setOpen(false); handleLogout(); }} className="text-left">Log out</button>
              </>
            ) : (
              <>
                <Link data-testid="nav-mobile-login" to="/login" onClick={() => setOpen(false)}>Log in</Link>
                <Link data-testid="nav-mobile-apply" to="/register" onClick={() => setOpen(false)} className="text-novya-accent">Apply now →</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
